import React from "react";
import { useTranslation } from "react-i18next";

import "./FolderSelectionDialog.css";

const FolderSelectionDialog = ({
    folders,
    selectedFolderId,
    rootFolderId,
    onSelectFolder,
    onClose
}) => {
    const { t } = useTranslation();
    const availableFolders = folders
        ? folders.filter(folder => folder.id !== selectedFolderId && folder.id !== rootFolderId)
        : [];

    return (
        <div className="folder-selection-overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
            <div className="folder-selection-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="folder-selection-header">
                    <h3>{t('folderSelectionDialog.moveToFolder')}</h3>
                    <button className="close-button" onClick={onClose}>×</button>
                </div>
                <div className="folder-selection-content">
                    {availableFolders.length === 0 ? (
                        <p>{t('folderSelectionDialog.noFolderToMove')}</p>
                    ) : (
                        <ul className="folder-selection-items">
                            {availableFolders.map((folder) => (
                                <li
                                    key={folder.id}
                                    className="folder-selection-item"
                                    onClick={() => {
                                        onSelectFolder(folder.id);
                                        onClose();
                                    }}
                                >
                                    {folder.name}
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FolderSelectionDialog;
